import React from 'react'
import { connect } from 'react-redux'
import { Link, browserHistory } from 'react-router'
import styles from './CollectionCard.scss'
import { collectionsMessages } from 'features/homepage/Collections/intlMessages'
import { Card } from 'common/styleguide/Card'
import { Distance, Elevation } from 'common/units'
import { Icon } from 'common/Icon'
import { UserCard } from 'common/hovercards/UserCard'
import { Loadable } from 'common/Loadable'
import { Msg, commonNouns, commonMessages } from 'lib/localization'
import { missingPhoto } from 'lib/photoUtils'
import { urls } from 'lib/urls'
import { userSelectors, userActions } from 'data/resources/users'
import _ from 'lodash'
import cx from 'classnames'

export class _CollectionCard extends React.PureComponent {
  // don't allow clicks on user link to bubble
  userLink = e => {
    e.preventDefault()
    browserHistory.push(urls.users.show(this.props.collection.userId))
  }

  render () {
    const { collection: c, user, currentUser, isMobile } = this.props

    return (
      <Card noPadding className={cx(styles.CollectionCard, isMobile && styles.collapsed)}>
        <Link to={urls.collections.show(c.id, c.privacyCode)}>
          <div className={styles.top}>
            {missingPhoto(c.cover)
              ? <Icon size={40} i='dynamic-feed' />
              : <img height='160' src={c.cover} />}
          </div>
          <div className={styles.bottom}>
            <h3>{c.title}</h3>
            <div className={styles.stats}>
              <div className={styles.distanceElevation}>
                <span><Distance bigUnits short value={_.get(c, 'stats.distance')} /></span>
                <span><Elevation short value={_.get(c, 'stats.elevation')} /></span>
              </div>
              <div className={styles.itemsUser}>
                <div className={styles.numItems}>{c.stats.items} <Msg m={commonNouns.items} values={{ count: c.stats.items }} /></div>
                {c.userId !== currentUser.id && <UserCard id={c.userId}>
                  <a onClick={this.userLink} className={styles.owner}><Msg m={commonMessages.byline} values={{ author: user.name }} /></a>
                </UserCard>}
              </div>
            </div>
          </div>
        </Link>
      </Card>
    )
  }
}

const loadInitialResources = ({ collection, currentUser, loadUser }) => (
  collection.userId !== currentUser.id
    ? loadUser(collection.userId)
    : Promise.resolve()
)

const LoadableCollectionCard = (props) => {
  return <Loadable
    {...props}
    component={_CollectionCard}
    loadingText={<Msg m={collectionsMessages.loadingCollection} />}
    resourceLoaded={() => loadInitialResources(props)} />
}

const mapStateToProps = (state, ownProps) => ({
  user: userSelectors.find(state, ownProps.collection.userId)
})

export const CollectionCard = connect(
  mapStateToProps,
  { loadUser: userActions.read }
)(LoadableCollectionCard)
